import { render } from "./PeopleDirectory.vue?vue&type=template&id=7a7ca55c&scoped=true"
import script from "./PeopleDirectory.vue?vue&type=script&lang=js"
export * from "./PeopleDirectory.vue?vue&type=script&lang=js"

import "./PeopleDirectory.vue?vue&type=style&index=0&id=7a7ca55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7ca55c"]])

export default __exports__